<div class="overlap_panel_wrapper">
  <div class="overlap_panel_sidebar">
    <div class="side_header">
      <div class="cross_wrap">
        <a href="javascript:void(0);" (click)="close()">
          <img src="../../../../assets/img/cross_icon.svg" alt="" class="icon">
        </a>
      </div>
      <p></p>
      <div class="back_wrap" >
        @if (stepper.selectedIndex > 0) {
          <a (click)="goBack(stepper)" class="back-button">
            <img src="../../../../assets/img/left_orange_arrow.svg" alt="Back" class="arrow">
            <span>Back</span>
          </a>
        }
      </div>
    </div>
    <div class="sidebar_accordion">
      <app-subcontractor-step-preview [model]="model" [step]="step" [form]="subcontractorFrom"></app-subcontractor-step-preview>
    </div>
  </div>
  <div class="overlap_right_panel">
    <form [formGroup]="subcontractorFrom" (ngSubmit)="onSubmit()" novalidate>
      <mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="onStepChanged($event, stepper)">
        <mat-step formGroupName="step01" [stepControl]="subcontractorFrom.get('step01')!">
          <ng-template matStepLabel>Subcontractor</ng-template>
          <app-subcontractor-add-form
            [isEdit]="isEdit"
            (callback)="changedHandler($event)"
            formControlName="addSubcontractor"
            [model]="model"
            [form]="subcontractorFrom.get('step01')"
            (onInitForm)="initChildForm('step01', 'addSubcontractor',$event.value)"
            >
          </app-subcontractor-add-form>
          <div class="controls">
            <button type="button" mat-button class="btn_transparent" (click)="close()">Cancel</button>
            <button type="button" mat-button matStepperNext class="btn_solid_color" (click)="touchFormControls('step01')">Next  <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>
        <mat-step formGroupName="step02" [stepControl]="subcontractorFrom.get('step02')!">
          <ng-template matStepLabel> Detail</ng-template>
          <app-subcontractor-detail-form
            [isEdit]="isEdit"
            (callback)="changedHandler($event)"
            formControlName="subcontractorDetail"
            [model]="model"
            [form]="subcontractorFrom.get('step02')"
            (onInitForm)="initChildForm('step02', 'subcontractorDetail',$event.value)"
            >
          </app-subcontractor-detail-form>
          <div class="controls">
            <button type="button" mat-button matStepperPrevious class="btn_transparent">Back</button>
            <button type="button" mat-button matStepperNext class="btn_solid_color" (click)="touchFormControls('step02')">Next <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>
        <!-- <mat-step formGroupName="step03" [stepControl]="subcontractorFrom.get('step03')!" *ngIf="!model">
        <ng-template matStepLabel> Contact</ng-template>
        <app-subcontractor-contact
          [isEdit]="isEdit"
          (callback)="changedHandler($event)"
          [isStandalone]="false"
          formControlName="subcontractorContact"
          [model]="model"
          [form]="subcontractorFrom.get('step03')"
          (onInitForm)="initChildForm('step03', 'subcontractorContact',$event.value)"
          >
        </app-subcontractor-contact>
        <div class="controls">
          <button type="button" mat-button matStepperPrevious class="btn_transparent">Back</button>
          <button type="button" mat-button matStepperNext class="btn_solid_color" (click)="touchFormControls('step03')">Next <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
        </div>
      </mat-step> -->

      <mat-step formGroupName="step04" [stepControl]="subcontractorFrom.get('step04')!">
        <ng-template matStepLabel> Certificates</ng-template>
        <app-subcontractor-certificate-form
          (callback)="changedHandler($event)"
          formControlName="subcontractorCertificates"
          [model]="model"
          [form]="subcontractorFrom.get('step04')"
          (onInitForm)="initChildForm('step04', 'subcontractorCertificates',$event.value)"
          [isEdit]="isEdit"
          >
        </app-subcontractor-certificate-form>
        <div class="controls">
          <button type="button" mat-button matStepperPrevious class="btn_transparent">Back</button>
          <button type="button" mat-button matStepperNext class="btn_solid_color" (click)="touchFormControls('step04')">Next <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
        </div>
      </mat-step>

      <mat-step formGroupName="step05" [stepControl]="subcontractorFrom.get('step05')!">
        <ng-template matStepLabel>Covered Areas</ng-template>
        <app-subcontractor-add-covered-area-form
          (callback)="changedHandler($event)"
          [isEdit]="isEdit"
          formControlName="addCoveredAreas"
          [model]="model"
          [form]="subcontractorFrom.get('step05')"
          (onInitForm)="initChildForm('step05', 'addCoveredAreas',$event.value)"
          >
        </app-subcontractor-add-covered-area-form>
        <div class="controls">
          <button type="button" mat-button matStepperPrevious class="btn_transparent">Back</button>
          <button type="button" mat-button matStepperNext class="btn_solid_color" (click)="touchFormControls('step05')">Preview <img src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
        </div>
      </mat-step>

      <mat-step formGroupName="step06" [stepControl]="subcontractorFrom.get('step06')!">
        <ng-template matStepLabel>Preview</ng-template>
        <app-subcontractor-final-preview [model]="model" [form]="subcontractorFrom"></app-subcontractor-final-preview>
        <div class="controls">
          <button type="button" mat-button matStepperPrevious class="btn_transparent">Back</button>
          <button mat-button [disabled]="subcontractorFrom.invalid || isSaving" type="submit" class="btn_solid_color">
            @if (isSaving) {
              <mat-progress-spinner
                diameter="16"
                strokeWidth="3"
                mode="indeterminate"
                color="accent"
                class="btn-spinner mr-3">
              </mat-progress-spinner>
            }
            <span class="btn-label">Save</span>
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</div>
</div>
